module.exports = __webpack_public_path__ + "img/bttn_motcomb_map.fe7fddff.png";